// Раскрываемая группа бокового меню (дизайн-сборка pwa-design@insights):
// родитель с иконкой и шевроном, поднавигация с левой чертой. Прямой заход
// на подстраницу раскрывает группу. Ported verbatim from the design
// workspace AppShell.tsx (the subnav CSS already lives in
// AppShell.module.css); a separate file — one component per file.

import { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { IconChevronDown } from '@tabler/icons-react'
import type { NavItem } from './appShellNav'
import styles from './AppShell.module.css'

export default function NavGroup({ item, onNavigate }: { item: NavItem; onNavigate: (to: string) => void }) {
  const location = useLocation()
  const ParentIcon = item.Icon
  const children = item.children ?? []
  const childActive = children.some((child) => child.to === location.pathname)
  const [open, setOpen] = useState(childActive)

  // Прямой заход на подстраницу раскрывает группу.
  useEffect(() => {
    if (childActive) setOpen(true)
  }, [childActive])

  return (
    <div className={`${styles.navGroup} ${open ? styles.navGroupOpen : ''}`}>
      <button
        type="button"
        className={`${styles.navItem} ${styles.groupToggle}`}
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span className={styles.navLeft}>
          {ParentIcon && <ParentIcon className={styles.navIconSvg} size={32} stroke={1.7} />}
          <span>{item.label}</span>
        </span>
        <IconChevronDown className={styles.chevron} size={18} stroke={2} />
      </button>
      {open && (
        <div className={styles.subnav} role="group" aria-label={item.label}>
          {children.map((child) => {
            const ChildIcon = child.Icon
            return (
              <NavLink
                key={child.to}
                to={child.to}
                className={({ isActive }) => `${styles.subItem} ${isActive ? styles.subItemActive : ''}`}
                onClick={() => onNavigate(child.to)}
              >
                <ChildIcon className={styles.subIcon} size={18} stroke={1.75} />
                <span>{child.label}</span>
              </NavLink>
            )
          })}
        </div>
      )}
    </div>
  )
}
